import { render, staticRenderFns } from "./MaintenancePage.vue?vue&type=template&id=5a09643e&"
import script from "./MaintenancePage.vue?vue&type=script&lang=js&"
export * from "./MaintenancePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports